"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _oss = require("../../../utils/oss");

var _util = require("../../../utils/util");

var _followBook = require("../../../api/followBook");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'index',
  data: function data() {
    return {
      valuePath: '',
      fullscreenLoading: false,
      headers: {
        'x-auth-token': localStorage.getItem('token'),
        'Content-type': 'multipart/form-data'
      },
      limitNum: 1,
      formLabelWidth: '80px',
      form: {
        file: ''
      },
      fileList: []
    };
  },
  methods: {
    exceedFile: function exceedFile(files, fileList) {
      this.$notify.warning({
        title: '警告',
        message: "\u53EA\u80FD\u9009\u62E9 ".concat(this.limitNum, " \u4E2A\u6587\u4EF6\uFF0C\u5F53\u524D\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A")
      });
    },
    // 文件状态改变时的钩子
    fileChange: function () {
      var _fileChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var res, str;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _oss.upload)(file.raw, (0, _oss.getPath)("excel/".concat((0, _util.randomString)()).concat((0, _util.getFileExt)(file))));

              case 3:
                res = _context.sent;
                console.log('上传到oss返回值', res);

                if (!res) {
                  this.$notify.error({
                    title: '失败',
                    message: '上传到oss失败'
                  });
                }

                this.$notify.success({
                  title: '成功',
                  message: '成功上传到oss'
                }); // const str = res.substring(12, res.length);

                str = res.replace('follow-book/', '');
                this.valuePath = str;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                this.$notify.error({
                  title: '失败',
                  message: _context.t0.message
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function fileChange(_x) {
        return _fileChange.apply(this, arguments);
      }

      return fileChange;
    }(),
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile: function beforeUploadFile(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      var size = file.size / 1024 / 1024;

      if (extension !== 'xlsx') {
        this.$notify.warning({
          title: '警告',
          message: '只能上传Excel2017（即后缀是.xlsx）的文件'
        });
      }

      if (size > 10) {
        this.$notify.warning({
          title: '警告',
          message: '文件大小不得超过10M'
        });
      }
    },

    /* 移除 */
    handleRemove: function handleRemove() {
      this.valuePath = '';
    },
    upExcleApi: function () {
      var _upExcleApi = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, bol;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.fullscreenLoading = true;
                console.log('上传Excel到数据库url数值', this.valuePath);
                _context2.next = 5;
                return (0, _followBook.uploadExcle)(this.valuePath);

              case 5:
                res = _context2.sent;
                bol = res.data.success;
                console.log('上传Excel到数据库url数值 返回结果', res.data.success);

                if (!bol) {
                  this.$notify.error({
                    title: '失败',
                    message: '上传失败到数据库'
                  });
                } else {
                  this.$notify.success({
                    title: '成功',
                    message: '上传成功到数据库'
                  });
                }

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                this.$message({
                  type: 'error',
                  message: _context2.t0.message
                });

              case 14:
                _context2.prev = 14;
                this.fullscreenLoading = false;
                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 11, 14, 17]]);
      }));

      function upExcleApi() {
        return _upExcleApi.apply(this, arguments);
      }

      return upExcleApi;
    }(),
    uploadFile: function uploadFile() {
      if (this.valuePath) {
        this.upExcleApi();
      } else {
        this.$notify.warning({
          title: '警告',
          message: '请选择文件'
        });
      }
    }
  }
};
exports.default = _default;